<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row">
        <div v-show="showData" class="col-lg-12">

          <AppForm
            ref="pageForm"
            v-bind:formParameter="PARAM" />

        </div>
      </div>

      <br>

      <button v-show="allowSave && showData" v-on:click="onSaveButtonClick" type="button" class="btn btn-primary">
        Save
      </button>

      <br>
      <br>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    form_section: 'Passcard Management',
  },
  {
    key: 'isSellPasscard',
    form_label_attr: {style:'display:none'},
    form_radio: [
      {
        0:'Passcard Return',
        form_muted: 'Return Passcard after termination effective date to complete termination process.',
      },
      {
        1:'Passcard Not Return', 
        form_muted: 'Sell Passcard upon apply of Parking License. Passcard not return after termination effective date.',
      }
    ],
  },
  {
    form_section: 'Account FTP Export Setting',
  },
  {
    key: '1',
    text: 'Host',
    form_muted: 'Enter the host of the FTP server.',
  },
  {
    key: '2',
    text: 'Username',
    form_muted: 'Enter the username used to connect to the FTP server.',
  },
  {
    key: '3',
    text: 'Password',
    form_muted: 'Enter the password used to connect to the FTP server.',
  },
  {
    key: '4',
    text: 'Port',
    form_muted: 'Enter the port used to connect to the FTP server.',
  },
  {
    key: '5',
    text: 'Directory',
    form_muted: 'Enter the directory (path) where exported csv files should be placed on the FTP server.',
  },
];

export default {
  name: "PageSetting",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    AppForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Administration' },
        { name: 'System Configuration' },
      ],

      PARAM,

      showData: false,
      allowSave: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    if(helper.hasEditPermission(this.permission)) {
      this.allowSave = true;
    }
    
    // this.loadCity();
    this.loadData();
  },
  methods: {
    loadData() {
      let feedbackItem = 'system configuration'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/configure',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.$refs['pageForm'].setForm(false, response.data[0]);
          this.showData = true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    onSaveButtonClick() {
      let formData = this.$refs['pageForm'].formData;
      let feedbackItem = 'system configuration'
      this.$refs['pageFeedback'].setFeedbackLoading('Saving ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/configure',
          querystring.stringify({
            configure: formData.configure,
            isSellPasscard: formData.isSellPasscard,
          }),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully save ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'saving', feedbackItem));
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageSetting.vue